import userFriendlyEr from '@/utils/userFriendlyEr'

export default {
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: null,
    }
  },
  computed: {
    globalError() {
      return this.$store.getters.getError
    },
  },
  watch: {
    globalError: 'onGlobalError',
  },
  methods: {
    onGlobalError() {
      // if authorization error, unset error for show login form
      if (this.globalError && this.globalError.status === 401) {
        this.$store.commit('mutateError', null)
      }
    },
    onSubmit() {
      this.loading = true
      this.error = null
      this.$store
        .dispatch('userLogin', {
          username: this.username.trim(),
          password: this.password.trim(),
        })
        .then(() => {
          this.$router.push(this.$store.getters.redirectUrl)
        })
        .catch((e) => {
          console.warn('Login error', e)
          this.error = userFriendlyEr.recognize(e)
          this.loading = false
        })
    },
    copyUrl(e) {
      const button = e.target
      const link = button.previousElementSibling
      const input = document.body.appendChild(document.createElement('input'))
      input.value = window.location.host + link.getAttribute('href')
      input.focus()
      input.select()
      document.execCommand('copy')
      input.parentNode.removeChild(input)
    },
  },
  asyncData() {
    return Promise.resolve(1)
  },
}
